export default {"src":"/_next/static/media/icon_play_view_less.cf802e59.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};